import { useHistory } from 'react-router-dom';

import { HASHES, FULL_PATHS } from '../constants';
import { useDetectionTracks } from '.';

/**
 * Returns a LocationDescriptor that can be used with react-router-dom to send the user to the
 * Uploads tab of the Manage Detections modal if they do not have any audio files uploaded.
 * Otherwise, sends them to the Detection Settings tab of the Manage Detections modal.
 *
 * A LocationDescriptor returned by this function looks like:
 *  ```
 *  {
 *      hash: '#detection-settings',  // `hash` sets the initial tab of the Manage Detections modal
 *      pathname: '/detections/manage',
 *      search: '?entity_id=AS01558069&statement_ids=1617756547AS0155806920202W', // `search` is already set on the location based on entity / statement selection
 *  }
 *  ```
 *
 * Which results in a final path like:
 *  ```
 *  '/detections/manage?entity_id=AS01558069&statement_ids=1617756547AS0155806920202W#detection-settings'
 *  ```
 */
export const useManageDetectionsLocation =
    (): import('history').LocationDescriptor => {
        const history = useHistory();
        const { detectionTracks } = useDetectionTracks();

        const hash =
            detectionTracks.length < 1
                ? HASHES.MANAGE_DETECTIONS.UPLOADS
                : HASHES.MANAGE_DETECTIONS.DETECTION_SETTINGS;

        return {
            search: history?.location?.search,
            pathname: FULL_PATHS.MANAGE_DETECTIONS,
            hash,
        };
    };
